import { ServerResponse } from 'data/types';
import { AnyAction } from 'redux';
import { AxiosPromise, AxiosResponse } from 'axios';
import { ThunkAction } from 'redux-thunk';
import { RootState } from 'data/root.reducers';

export const API_PATH_JURISDICTION_AREA = '/jareas'; // @sumedh

export const GO_TO_JURISDICTION_AREA_LIST = 'GO_TO_JURISDICTION_AREA_LIST';
export const GET_JURISDICTION_AREA_LIST = 'GET_JURISDICTION_AREA_LIST';
export const GET_JURISDICTION_AREA_LIST_PENDING =
  'GET_JURISDICTION_AREA_LIST_PENDING';
export const GET_JURISDICTION_AREA_LIST_FULFILLED =
  'GET_JURISDICTION_AREA_LIST_FULFILLED';
export const CREATE_JURISDICTION_AREA = 'CREATE_JURISDICTION_AREA';
export const CREATE_JURISDICTION_AREA_PENDING =
  'CREATE_JURISDICTION_AREA_PENDING';
export const CREATE_JURISDICTION_AREA_FULFILLED =
  'CREATE_JURISDICTION_AREA_FULFILLED';
export const CREATE_JURISDICTION_AREA_REJECTED =
  'CREATE_JURISDICTION_AREA_REJECTED';
export const DELETE_JURISDICTION_AREA = 'DELETE_JURISDICTION_AREA';
export const DELETE_JURISDICTION_AREA_FULFILLED =
  'DELETE_JURISDICTION_AREA_FULFILLED';
export const DELETE_JURISDICTION_AREA_REJECTED =
  'DELETE_JURISDICTION_AREA_REJECTED';
export const SELECT_JURISDICTION_AREA = 'SELECT_JURISDICTION_AREA';
export const OPEN_JURISDICTION_AREA_CREATE_PAGE =
  'OPEN_JURISDICTION_AREA_CREATE_PAGE';
export const CLOSE_JURISDICTION_AREA_CREATE_PAGE =
  'CLOSE_JURISDICTION_AREA_CREATE_PAGE';
export const OPEN_JURISDICTION_AREA_EDIT_PAGE =
  'OPEN_JURISDICTION_AREA_EDIT_PAGE';
export const CLOSE_JURISDICTION_AREA_EDIT_PAGE =
  'CLOSE_JURISDICTION_AREA_EDIT_PAGE';
export const GO_TO_JURISDICTION_AREA_VIEW = 'GO_TO_JURISDICTION_AREA_VIEW';

export enum JurisdictionAreaPrivileges {
  View = 'cf_view',
  Edit = 'cf_write',
  Delete = 'cf_delete'
}

export type JurisdictionArea = {
  id: string;
  SS8ID: string;
  AFID: string;
  AFTYPE?: string;
  AFNAME?: string;
  ACCESS?: string;
  GROUP?: string;
  OWNER?: string;
};

export type JurisdictionAreaCreateBody = {
  ID: string;
  AFID: string;
}

export type JurisdictionAreaGridData = {
  id: string;
  SS8ID: string;
  AFID: string;
  AFTYPE: string;
  AFNAME: string;
  ACCESS?: string;
  GROUP?: string;
  OWNER?: string;
}

export type JAreaAfRowData = {
  id: string;
  AFTYPE: string;
  AFNAME: string;
}

export interface JurisdictionAreaState {
  entities: JurisdictionArea[];
  single: JurisdictionArea | null;
  selected: JurisdictionAreaGridData[];
  createdId: string | null;
  ui: JurisdictionAreaUIState;
}

export type JurisdictionAreaUIState = {
  isCreatePopupOpen: boolean;
  isEditPopupOpen: boolean;
  isLoading: boolean;
};

export interface GoToJurisdictionAreaListAction extends AnyAction {
  type: typeof GO_TO_JURISDICTION_AREA_LIST;
}

export interface openJurisdictionAreaCreatePageAction extends AnyAction {
  type: typeof OPEN_JURISDICTION_AREA_CREATE_PAGE;
}

export interface closeJurisdictionAreaCreatePageAction extends AnyAction {
  type: typeof CLOSE_JURISDICTION_AREA_CREATE_PAGE;
}

export interface openJurisdictionAreaEditPageAction extends AnyAction {
  type: typeof OPEN_JURISDICTION_AREA_EDIT_PAGE;
}

export interface closeJurisdictionAreaEditPageAction extends AnyAction {
  type: typeof CLOSE_JURISDICTION_AREA_EDIT_PAGE;
}

export interface GetJurisdictionAreaListAction extends AnyAction {
  type: typeof GET_JURISDICTION_AREA_LIST;
  payload: AxiosPromise<ServerResponse<JurisdictionArea>>;
}

export interface GetJurisdictionAreaListPendingAction extends AnyAction {
  type: typeof GET_JURISDICTION_AREA_LIST_PENDING;
  payload: null;
}

export interface GetJurisdictionAreaListFulfilledAction extends AnyAction {
  type: typeof GET_JURISDICTION_AREA_LIST_FULFILLED;
  payload: AxiosResponse<ServerResponse<JurisdictionArea>>;
}

export interface CreateJurisdictionAreaThunkAction
  extends ThunkAction<void, RootState, void, AnyAction> { }
export interface CreateJurisdictionAreaAction extends AnyAction {
  type: typeof CREATE_JURISDICTION_AREA;
  payload: AxiosPromise<ServerResponse<JurisdictionArea>>;
}

export interface CreateJurisdictionAreaPendingAction extends AnyAction {
  type: typeof CREATE_JURISDICTION_AREA_PENDING;
  payload: null;
}

export interface CreateJurisdictionAreaFulfilledAction extends AnyAction {
  type: typeof CREATE_JURISDICTION_AREA_FULFILLED;
  payload: AxiosResponse<ServerResponse<JurisdictionArea>>;
}

export interface CreateJurisdictionAreaRejectedAction extends AnyAction {
  type: typeof CREATE_JURISDICTION_AREA_REJECTED;
  payload: AxiosResponse<ServerResponse<JurisdictionArea>>;
}

export interface DeleteJurisdictionAreaThunkAction
  extends ThunkAction<void, RootState, void, AnyAction> { }
export interface DeleteJurisdictionAreaAction extends AnyAction {
  type: typeof DELETE_JURISDICTION_AREA;
  payload: AxiosPromise<ServerResponse<JurisdictionArea>>;
}

export interface DeleteJurisdictionAreaFulfilledAction extends AnyAction {
  type: typeof DELETE_JURISDICTION_AREA_FULFILLED;
  payload: AxiosResponse<ServerResponse<JurisdictionArea>>;
}

export interface DeleteJurisdictionAreaRejectedAction extends AnyAction {
  type: typeof DELETE_JURISDICTION_AREA_REJECTED;
  payload: AxiosResponse<ServerResponse<JurisdictionArea>>;
}

export interface SelectJurisdictionAreaAction extends AnyAction {
  type: typeof SELECT_JURISDICTION_AREA;
  payload: JurisdictionAreaGridData[];
}

export interface GoToJurisdictionAreaView extends AnyAction {
  type: typeof GO_TO_JURISDICTION_AREA_VIEW;
}

export type JurisdictionAreaActionTypes =
  | GoToJurisdictionAreaListAction
  | openJurisdictionAreaCreatePageAction
  | closeJurisdictionAreaCreatePageAction
  | openJurisdictionAreaEditPageAction
  | closeJurisdictionAreaEditPageAction
  | GetJurisdictionAreaListAction
  | GetJurisdictionAreaListPendingAction
  | GetJurisdictionAreaListFulfilledAction
  | CreateJurisdictionAreaAction
  | CreateJurisdictionAreaPendingAction
  | CreateJurisdictionAreaFulfilledAction
  | CreateJurisdictionAreaRejectedAction
  | DeleteJurisdictionAreaAction
  | DeleteJurisdictionAreaFulfilledAction
  | DeleteJurisdictionAreaRejectedAction
  | SelectJurisdictionAreaAction
  | GoToJurisdictionAreaView;
